import { assignExperimentVariant, updateExperimentGoal, ExperimentAssignRequestPayload, ExperimentGoalUpdateRequest } from "./api";
import { UIUtils } from "./uiUtils";

export const runAssignment = async (payload: ExperimentAssignRequestPayload) => {
  const response = await assignExperimentVariant(payload);
  const { experiment_id, entity_id_key } = payload;
  const { random_number, challenger_id, experiment_tracker_id } = response.data;

  // Track in New Relic
  UIUtils.trackABTest("ab_test_assignment", {
    experiment_id,
    entity_id_key: entity_id_key ?? "unknown",
    challenger_id,
    random_number,
    experiment_tracker_id,
  });

  // Track in Microsoft Clarity if available
  try {
    if (typeof window !== "undefined" && (window as any).clarity) {
      (window as any).clarity("set", experiment_id, challenger_id);
    }
  } catch (err) {
    // swallow clarity errors to avoid breaking flow
  }

  return response;
};

export const recordGoal = async (payload: ExperimentGoalUpdateRequest) => {
  await updateExperimentGoal(payload);
  UIUtils.trackABTest("ab_test_goal_completed", {
    experiment_id: payload.experiment_id,
    entity_id_key: payload.entity_id_key ?? "unknown",
    goal_type: payload.goal_type,
    goal_value: payload.goal_value,
  });
};
